<template>
    <div v-if="widgetReady">
        <table class="fee-table">
            <tr>
                <td><span>Fee Name:</span></td>
                <td>{{fee.name}}</td>
            </tr>
            <tr>
                <td><span>Description:</span></td>
                <td>{{fee.description}}</td>
            </tr>
            <tr>
                <td><span>Fee type:</span></td>
                <td>
                    <span class="capitalizeFirst">{{feeType.name}}</span>
                    (<small>{{feeType.description}}</small>)
                </td>
            </tr>
            <tr>
                <td><span>Payment type:</span></td>
                <td class="capitalizeFirst">{{strategyType.name.toLowerCase()}}</td>
            </tr>
            <tr>
                <td><span>Amount:</span></td>
                <td>
                    <span v-if="fee.strategyTypeId===STRATEGY_TYPES.FIXED_FEE"> {{fee.formula | currency}} </span>
                    <span v-if="fee.strategyTypeId===STRATEGY_TYPES.PERCENTAGE"> {{fee.formula | percentage(false)}} of plan price</span>
                    <span v-if="fee.strategyTypeId===STRATEGY_TYPES.CUSTOM"> Custom </span>
                </td>
            </tr>
            <tr v-if="fee.payerRef && fee.payerRef.displayName">
                <td><span>Payer:</span></td>
                <td>{{fee.payerRef.displayName}}</td>
            </tr>
            <tr v-if="fee.payerRef && fee.payerRef.displayName">
                <td><span>Is this a new payer:</span></td>
                <td>{{fee.payerRef.isNew | booleanDisplay}}</td>
            </tr>
            <tr>
                <td><span>Payee:</span></td>
                <td>{{fee.payeeRef.displayName}}</td>
            </tr>
            <tr>
                <td><span>Is this a new payee:</span></td>
                <td>{{fee.payeeRef.isNew | booleanDisplay}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {configTables} from "../../../global/configTables.js";
    import _ from 'lodash';
    import {common} from "../../../global/common.js";

    export default {
        name: "FeeReview",
        props: {fee: {type: [Object], required: true}},
        data() {
            return {
                widgetReady: false,
                strategyType: '',
                feeType: '',
                STRATEGY_TYPES: common.PAYMENT_STRATEGY_TYPES
            };
        },
        async mounted() {
            let [strategies, feeTypes] = await Promise.all([
                configTables.getPaymentStrategyTypes(), configTables.getFeeTypes(false)
            ]);
            this.strategyType = _.find(strategies, {strategyTypeId: this.fee.strategyTypeId});
            this.feeType = _.find(feeTypes, {feeTypeId: this.fee.feeTypeId});
            this.widgetReady = true;
        }
    }
</script>

<style scoped>
    .fee-desc li {
        padding: 10px;
        font-size: 14px;
    }

    .fee-desc li span:first-child {
        font-weight: bold;
        margin-right: 5px;
    }

    .fee-table {
        border: none;
        font-size: 14px;
        width: 100%;
    }

    .feeTable tr td {
        padding-bottom: 5px !important;
    }

    .fee-table tr td:first-child {
        font-weight: bold;
        padding-right: 5px;
        padding-left: 10px;
        padding-bottom: 5px !important;
        width: auto;
        white-space: nowrap;
        vertical-align: center;
    }

    .capitalizeFirst:first-letter {
        text-transform: capitalize;
    }

</style>